export const LIMITS_CONSTANTS = {
	GAMES_MAX_DEPOSIT: 1000,
	GENERAL_MAX_AMOUNT: 99999999,
	MONTHLY_DURATION_UNITS: 30,
} as const;
